<div class="phone-input">
  <label *ngIf="label" class="phone-label">{{ label }}</label>

  <div class="phone-field" [class.invalid]="!!errorMessage">
    <select [formControl]="prefixCtrl" class="prefix-select">
      <option *ngFor="let prefix of availablePrefixes" [value]="prefix">
        {{ prefix }}
      </option>
    </select>

    <input
      type="tel"
      [formControl]="nationalCtrl"
      [maxlength]="formattedMaxLength"
      (keydown)="blockNonNumeric($event)"
      (blur)="onBlur()"
      [placeholder]="placeholderExample"
      class="phone-input-field"
    />
  </div>

  <div class="error-message" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>
</div>
